import React from "react";

export function LabeledInput({
  children,
  value,
  setValue,
  secureEntry,
  onFocus,
  onBlur,
  error,
  disabled,
  inputMode,
  autoFocus,
  inputStyles,
}: {
  children: any;
  value: string;
  setValue: any;
  inputStyles?: any;
  secureEntry?: boolean;
  onFocus?: any;
  onBlur?: any;
  error?: string;
  disabled?: boolean;
  inputMode?: "email" | "numeric" | "tel";
  autoFocus?: boolean;
}) {
  return (
    <div className="p-field" style={{ marginBottom: 18 }}>
      <label className="p-label">{children}</label>
      <input
        className="p-input"
        inputMode={inputMode ?? "text"}
        value={value}
        disabled={disabled}
        type={secureEntry ? "password" : "text"}
        style={inputStyles}
        onChange={(e) => setValue(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={autoFocus}
      />
      {error && <div style={{ fontSize: 12, color: "var(--maroon)" }}>{error}</div>}
    </div>
  );
}

export function HalfLabeledInput({
  children,
  value,
  setValue,
  secureEntry,
  withMarginRight,
  disabled,
  onFocus,
  onBlur,
  error,
  inputStyles,
}: {
  children?: any;
  value: string;
  setValue: any;
  inputStyles?: any;
  secureEntry?: boolean;
  disabled?: boolean;
  withMarginRight?: boolean;
  onFocus?: any;
  onBlur?: any;
  error?: string;
}) {
  return (
    <div className="p-field" style={{ marginBottom: 18, marginRight: withMarginRight ? 20 : 0, flex: 1 }}>
      {children && <label className="p-label">{children}</label>}
      <input
        className="p-input"
        disabled={disabled}
        value={value}
        type={secureEntry ? "password" : "text"}
        style={inputStyles}
        onChange={(e) => setValue(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {error && <div style={{ fontSize: 12, color: "var(--maroon)" }}>{error}</div>}
    </div>
  );
}

export function MultilineLabeledInput({
  children,
  value,
  setValue,
  onFocus,
  onBlur,
  error,
  disabled,
  inputStyles,
}: {
  children: any;
  value: string;
  setValue: any;
  inputStyles?: any;
  secureEntry?: boolean;
  onFocus?: any;
  onBlur?: any;
  error?: string;
  disabled?: boolean;
}) {
  return (
    <div className="p-field" style={{ marginBottom: 18 }}>
      <label className="p-label">{children}</label>
      <textarea
        className="p-input"
        value={value}
        disabled={disabled}
        rows={4}
        style={{ resize: "vertical", ...inputStyles }}
        onChange={(e) => setValue(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {error && <div style={{ fontSize: 12, color: "var(--maroon)" }}>{error}</div>}
    </div>
  );
}

export function LabeledRadioButtons({
  children,
  value,
  setValue,
  disabled,
  containerStyles,
  radioName,
}: {
  children: any;
  value: boolean;
  setValue: any;
  inputStyles?: any;
  disabled?: boolean;
  containerStyles?: any;
  radioName?: string;
}) {
  return (
    <div className="p-field" style={{ marginBottom: 18, ...containerStyles }}>
      <label className="p-label">{children}</label>
      <div style={{ display: "flex", gap: 16, marginTop: 4 }}>
        {[true, false].map((v) => (
          <label key={String(v)} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14 }}>
            <input
              name={radioName ?? "r-1"}
              type="radio"
              checked={value === v}
              onChange={() => setValue(v)}
              disabled={disabled}
            />
            {v ? "Yes" : "No"}
          </label>
        ))}
      </div>
    </div>
  );
}

// Keep SimpleInput as a pass-through for backwards compat
export const SimpleInput = (props: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input {...props} className={`p-input ${props.className ?? ""}`} style={{ width: "100%", ...props.style }} />
);

export const SimpleTextArea = (props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) => (
  <textarea {...props} className={`p-input ${props.className ?? ""}`} style={{ width: "100%", resize: "vertical", ...props.style }} />
);

export const FakeInputButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button {...props} className={`p-input ${props.className ?? ""}`} style={{ textAlign: "left", cursor: "pointer", ...props.style }} />
);
